module.exports = __webpack_public_path__ + "static/media/img-2.25e3510e.jpg";